import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Per-file upload cap (Cloudinary free tier allows up to ~100MB for video).
export const MAX_UPLOAD_BYTES = 100 * 1024 * 1024;

// Uploads a single file straight to Cloudinary using a signature minted by our
// backend (the API secret never reaches the browser). Returns the secure URL.
export const uploadToCloudinary = async (file) => {
  if (file.size > MAX_UPLOAD_BYTES) {
    throw new Error(`"${file.name}" is larger than 100MB`);
  }

  // 1. Ask our backend to sign the upload (axios carries the auth token).
  const { data: sig } = await axios.get(`${API_URL}/media/upload-signature`);

  // 2. Upload directly to Cloudinary with the signed params. Use fetch so we
  //    don't send our Authorization header to a third party.
  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);

  const endpoint = `https://api.cloudinary.com/v1_1/${sig.cloud_name}/auto/upload`;
  const res = await fetch(endpoint, { method: "POST", body: form });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.error?.message || "Upload failed");
  }

  const data = await res.json();
  return data.secure_url;
};
